/* eslint-disable @typescript-eslint/no-explicit-any */

import { MultiSelectOption } from 'components/common/ReactSelect/MultiSelectInput';

export type UserStatus = {
  variant: 'info' | 'success' | 'pending';
  name: string;
};

export type UserAccountData = {
  userAccounts: UserAccount[];
};

export enum USER_ACCESS {
  FULL = 'FULL',
  USER = 'USER',
  READ_LOG = 'READ_LOG',
  LIMITED = 'LIMITED',
}

export enum USER_STATUS {
  INVITED = 'INVITED',
  ACTIVE = 'ACTIVE',
}

export enum USER_SOURCE {
  API = 'API',
  OTHER = 'OTHER',
  SCIM = 'SCIM',
  WEB = 'WEB',
}

export type UserAccount = {
  email: string;
  access: USER_ACCESS;
  status: USER_STATUS;
  source: USER_SOURCE;
};

export type Mutation = (email: MutationPayload) => Promise<any>;

export type RowData = UserAccount & {
  isWriteDisabled: boolean;
  resendInvite: Mutation;
  revokeInvite: Mutation;
  revokeAccess: Mutation;
  refetchData: () => void;
};

type MutationPayload = { variables: { email: string } };

export type DashboardItem = {
  name: string;
  __typename: string;
};

export type emailFormState = {
  email: MultiSelectOption[];
};

export type AddNewUserFormState = {
  emails: string[];
  access: string;
  allowedSearch: string;
  allowedDashboards: string[];
};

export type UserFormAction =
  | { type: 'setEmails'; payload: string[] }
  | { type: 'setAccess'; payload: string }
  | { type: 'setAllowedSearch'; payload: string }
  | { type: 'setAllowedDashboards'; payload: string[] }
  | { type: 'resetState'; payload: any }
  | { type: string; payload: any };
